__turbopack_context__.v({
  "sticky-cta-bar": "WgI9cW_sticky-cta-bar",
  "sticky-cta-bar-bounds": "WgI9cW_sticky-cta-bar-bounds",
  "sticky-cta-bar__button": "WgI9cW_sticky-cta-bar__button",
  "sticky-cta-bar__inner": "WgI9cW_sticky-cta-bar__inner",
  "sticky-cta-bar__message": "WgI9cW_sticky-cta-bar__message",
  "sticky-cta-bar__outer": "WgI9cW_sticky-cta-bar__outer",
});
